import React, {useEffect} from "react";
import {Button, Col, Row, Space, Table} from "antd";
import {ButtonExcel, ListActionButton} from "components/common";
import InputSearch from "components/common/InputSearch/InputSearch";

interface CatalogItemProps {
  nameCatalog: string;
  tableData: any;
  isBtnEdit?: boolean;
  onClickCreate?: () => void;
  onSearch?: (any) => void;
  onChangeSearch?: (any) => void;
  onClickEdit?: (data: any) => void;
  onClickRemove?: (id: string | number) => void;
  onClickReport?: () => void;
}

const CatalogItem = ({
  nameCatalog,
  tableData,
  isBtnEdit = false,
  onSearch,
  onChangeSearch,
  onClickCreate,
  onClickEdit,
  onClickRemove,
  onClickReport,
}: CatalogItemProps) => {
  useEffect(() => {
    setColumnAction();
  }, []);

  const setColumnAction = () => {
    if (tableData.columns.find(e => e.dataIndex == "action")) {
      tableData.columns.find(e => e.dataIndex == "action").render = (
        _,
        _record
      ) => {
        return (
          <ListActionButton
            deleteFunction={() => {
              onClickRemove(_record.id);
            }}
            editFunction={() => {
              onClickEdit(_record);
            }}
          ></ListActionButton>
        );
      };
    }
  };
  return (
    <Space
      direction="vertical"
      className="Store container"
      style={{width: "100%"}}
    >
      <Row justify={"space-between"}>
        <Col>
          {" "}
          <div className="title">{nameCatalog}</div>{" "}
        </Col>
        <Col>
          <Space>
            {onSearch && (
              <InputSearch
                placeholder="Nhập vật tư"
                onSearch={onSearch}
                onChange={onChangeSearch}
              ></InputSearch>
            )}
            {onClickReport && (
              <ButtonExcel onClick={onClickReport}></ButtonExcel>
            )}
            {isBtnEdit && (
              <Button
                type="primary"
                onClick={() => {
                  onClickCreate();
                }}
              >
                Thêm mới
              </Button>
            )}
          </Space>
        </Col>
      </Row>
      <div className="container-table">
        <Table
          bordered
          {...tableData}
          pagination={
            tableData.pagination
              ? {
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  ...tableData.pagination,
                }
              : false
          }
          dataSource={tableData.dataSource?.map((data, index) => ({
            ...data,
            key: data?.id || "_" + index,
          }))}
        ></Table>
      </div>
    </Space>
  );
};

export default CatalogItem;
